import { render } from "./ProjectStatusView.vue?vue&type=template&id=503280ef&scoped=true"
import script from "./ProjectStatusView.vue?vue&type=script&lang=js"
export * from "./ProjectStatusView.vue?vue&type=script&lang=js"

import "./ProjectStatusView.vue?vue&type=style&index=0&id=503280ef&scoped=true&lang=css"

import exportComponent from "C:\\onetap\\onetap\\frontend\\onetapuser\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503280ef"]])

export default __exports__